import { plainToClass } from "class-transformer";
import { CommunicationDropdown, ProjectFile, CommunicationAttachment, CommunicationsListingDto } from "../communications.objects";
import { AssignedSiteStudyDto } from "../../action-items/action-items.objects";
import { Unique } from "../../../../shared/scripts/array-functions";
import { IFilter } from "../../../../shared/scripts/filtering/filtering.entities";
import { InitializeFilterDropdown } from "../../../../shared/scripts/filtering/filtering.utilities";

export class CommunicationDialogReadonly implements IFilter {
    communicationTypes: CommunicationDropdown[];
    communicationTopics: CommunicationDropdown[];
    communicationStatuses: CommunicationDropdown[];
    attachmentTypes: CommunicationDropdown[];
    allSites: any[];
    allContacts: any[];
    allUsers: any[];
    sitesTable: any;
    contactsTable: any;
    usersTable: any;
    currentSiteName: string;
    actionItemsTable: any;
    attachmentsTable: any;
    actionItems: any[];
    attachments: any[];
    successCallback: (response: any) => void;
    assignedSites: any[];
    assignedContacts: any[];
    assignedUsers: any[];
    siteFilterDropdownIds: string[];
    contactFilterDropdownIds: string[];
    userFilterDropdownIds: string[];
    actionItemFilterDropdownIds: string[];
    attachmentFilterDropdownIds: string[];

    constructor(allCommunicationsJson: any, allCommunicationTypesJson: any, allCommunicationTopicsJson: any, allCommunicationStatusesJson: any, allAttachmentTypesJson: any, allSitesJson: any, allContactsJson: any, allUsersJson: any, currentSiteName: string='') {
        $(() => {
            this.currentSiteName = currentSiteName;
            this.communicationTypes = plainToClass(CommunicationDropdown, <CommunicationDropdown[]>allCommunicationTypesJson);
            this.communicationTopics = plainToClass(CommunicationDropdown, <CommunicationDropdown[]>allCommunicationTopicsJson);
            this.communicationStatuses = plainToClass(CommunicationDropdown, <CommunicationDropdown[]>allCommunicationStatusesJson);
            this.attachmentTypes = plainToClass(CommunicationDropdown, <CommunicationDropdown[]>allAttachmentTypesJson);
            this.allSites = plainToClass(Object, <any[]>allSitesJson);
            this.allContacts = plainToClass(Object, <any[]>allContactsJson);
            this.allUsers = plainToClass(Object, <any[]>allUsersJson);
            this.assignedSites = [];
            this.assignedContacts = [];
            this.assignedUsers = [];
            this.actionItems = [];
            this.attachments = [];
            this.siteFilterDropdownIds = [
                '#filter-site-study-dropdown'
            ];
            this.contactFilterDropdownIds = [
                '#filter-contact-study-dropdown', '#filter-contact-role-dropdown'
            ];
            this.userFilterDropdownIds = [
                '#filter-user-study-dropdown'
            ];
            this.actionItemFilterDropdownIds = [
                '#commActionItem-site-dropdown', '#commActionItem-status-dropdown', '#commActionItem-type-dropdown'
            ];
            this.attachmentFilterDropdownIds = [
                '#communicationEvent-attachmentType-dropdown'
            ];
            this.initializeSitesTable();
            this.initializeContactsTable();
            this.initializeUsersTable();
            this.initializeActionItemsTable();
            this.initializeAttachmentsTable();
            this.initializeSitesFilters();
            this.initializeContactsFilters();
            this.initializeUsersFilters();
            this.initializeActionItemsFilters();
            this.initializeAttachmentsFilters();
            $('#newCommunicationEventDialog').on('shown.bs.modal', () => {
                if (this.sitesTable) {
                    this.sitesTable.columns.adjust();
                }
                if (this.contactsTable) {
                    this.contactsTable.columns.adjust();
                }
                if (this.usersTable) {
                    this.usersTable.columns.adjust();
                }
                if (this.actionItemsTable) {
                    this.actionItemsTable.columns.adjust();
                }
                if (this.attachmentsTable) {
                    this.attachmentsTable.columns.adjust();
                }
            });
            $('#communicationDialogAttachmentSection').on('shown.bs.collapse', () => {
                if (this.attachmentsTable) {
                    this.attachmentsTable.columns.adjust();
                }
            });
            $('#communicationActionItemsSection').on('shown.bs.collapse', () => {
                if (this.actionItemsTable) {
                    this.actionItemsTable.columns.adjust();
                }
            });
            // Adjust columns when switching tabs in the dialog
            $('#newCommunicationEventDialog .ctms-st-menu a[data-toggle="tab"]').on('shown.bs.tab', () => {
                if ($('#tab1').hasClass('active') && this.sitesTable) {
                    this.sitesTable.columns.adjust();
                }
                if ($('#tab2').hasClass('active') && this.contactsTable) {
                    this.contactsTable.columns.adjust();
                }
                if ($('#tab3').hasClass('active') && this.usersTable) {
                    this.usersTable.columns.adjust();
                }
            });
            $('#communicationDialogTabSection').on('shown.bs.collapse', () => {
                if ($('#tab1').hasClass('active') && this.sitesTable) {
                    this.sitesTable.columns.adjust();
                }
                if ($('#tab2').hasClass('active') && this.contactsTable) {
                    this.contactsTable.columns.adjust();
                }
                if ($('#tab3').hasClass('active') && this.usersTable) {
                    this.usersTable.columns.adjust();
                }
            });
        });
    }

    populateDialogFieldsFromDto(dto: any): void {
        $('#communicationId').val(dto.id);
        const typeObj = this.communicationTypes.find(t => t.Id === dto.typeId);
        const topicObj = this.communicationTopics.find(t => t.Id === dto.topicId);
        const statusObj = this.communicationStatuses.find(t => t.Id === dto.statusId);
        $('#communicationTypeReadonly').text(typeObj ? typeObj.Name : '');
        $('#communicationDateReadonly').text(dto.date || '');
        $('#communicationStatusReadonly').text(statusObj ? statusObj.Name : '');
        $('#communicationTopicReadonly').text(topicObj ? topicObj.Name : '');
        $('#communicationEventSignificantReadonly').text(dto.isSignificant ? 'Yes' : 'No');
        $('#communicationCreatedByReadonly').text(dto.createdBy || 'Unknown');
        $('#communicationCreatedBy').text(dto.createdBy || 'Unknown');
        $('.communication-created-by').show();
        $('#communicationNotesReadonly').text(dto.notes || '');

        this.assignedSites = Array.isArray(dto.assignedSites)
            ? this.allSites.filter(site => dto.assignedSites.includes(site.Id))
            : [];
        this.assignedContacts = Array.isArray(dto.assignedContacts)
            ? this.allContacts.filter(contact => dto.assignedContacts.includes(contact.Id))
            : [];
        this.assignedUsers = Array.isArray(dto.assignedUsers)
            ? this.allUsers.filter(user => dto.assignedUsers.includes(user.Id))
            : [];
        this.actionItems = Array.isArray(dto.actionItems)
            ? dto.actionItems
            : [];
        this.attachments = Array.isArray(dto.attachments)
            ? dto.attachments
            : [];

        this.populateSitesTable(this.assignedSites);
        this.populateContactsTable(this.assignedContacts);
        this.populateUsersTable(this.assignedUsers);
        this.populateActionItemsTable(dto.actionItems || []);
        this.populateAttachmentsTable(dto.attachments || []);
        // Sites
        $("#tabLink1 .ctms-count").text(dto.assignedSites.length);
        // Contacts
        $("#tabLink2 .ctms-count").text(dto.assignedContacts.length);
        // Users
        $("#tabLink3 .ctms-count").text(dto.assignedUsers.length);
        this.initializeSitesFilters();
        this.initializeContactsFilters();
        this.initializeUsersFilters();
        this.initializeActionItemsFilters();
        this.initializeAttachmentsFilters();
    }

    initializeSitesTable(): void {
        this.sitesTable = $('#communications-sites-assign-table').DataTable({
            dom: 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '30vh',
            scrollCollapse: true,
            orderCellsTop: true,
            order: [[1, 'asc']],
            columns: [
                { data: "SiteName", title: "Site Name" },
                { data: "SiteNumber", title: "Site Number" },
                { data: "StudyName", title: "Study" }
            ],
            data: []
        });
    }

    populateSitesTable(sites: any[]): void {
        this.sitesTable.clear();
        this.sitesTable.rows.add(sites).draw();
    }

    initializeContactsTable(): void {
        this.contactsTable = $('#communications-contacts-assign-table').DataTable({
            dom: 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '30vh',
            scrollCollapse: true,
            orderCellsTop: true,
            order: [[0, 'asc']],
            columns: [
                { data: "ContactName", title: "Name" },
                { data: "SiteNames", title: "Site(s)", render: (data) => Array.isArray(data) ? data.join(", ") : data },
                { data: "StudyNameAndRole", title: "Study", render: (data) => Array.isArray(data) ? data.slice().sort().join(", ") : data }
            ],
            data: []
        });
    }

    populateContactsTable(contacts: any[]): void {
        this.contactsTable.clear();
        this.contactsTable.rows.add(contacts).draw();
        // Reapply site name search filter if set
        if (this.currentSiteName) {
            this.contactsTable.search(this.currentSiteName).draw();
        }
    }

    initializeUsersTable(): void {
        this.usersTable = $('#communications-users-assign-table').DataTable({
            dom: 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '30vh',
            scrollCollapse: true,
            orderCellsTop: true,
            order: [[0, 'asc']],
            columns: [
                { data: "Name", title: "Name" }
            ],
            data: []
        });
    }

    populateUsersTable(users: any[]): void {
        this.usersTable.clear();
        this.usersTable.rows.add(users).draw();
    }

    initializeActionItemsTable(): void {
        this.actionItemsTable = $('#action-items-table').DataTable({
            dom: 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '30vh',
            scrollCollapse: true,
            orderCellsTop: true,
            order: [[3, 'asc']],
            columns: [
                { data: "type", title: "Type" },
                { data: "status", title: "Status" },
                { data: "siteName", title: "Site" },
                { data: "dateDue", title: "Due Date" }
            ],
            data: []
        });
    }

    populateActionItemsTable(actionItems: any[]): void {
        this.actionItemsTable.clear();
        this.actionItemsTable.rows.add(actionItems).draw();
    }

    initializeAttachmentsTable(): void {
        this.attachmentsTable = $('#attachments-table').DataTable({
            dom: 'rtip',
            autoWidth: false,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            scrollY: '20vh',
            scrollCollapse: true,
            orderCellsTop: true,
            order: [[1, 'asc']],
            columns: [
                {
                    data: 'attachmentTypeId',
                    title: 'Attachment Type',
                    width: '150px',
                    render: (data, type, row) => {
                        const typeObj = this.attachmentTypes.find(t => t.Id == data);
                        return typeObj ? typeObj.Name : data;
                    }
                },
                {
                    data: 'fileName',
                    title: 'File Name',
                    render: (data, type, row) => {
                        if (!row.s3Id) return data;
                        const s3Id = encodeURIComponent(row.s3Id);
                        const fileName = encodeURIComponent(row.fileName);
                        return `<a href="/secure/ctms/communications/communications?handler=DownloadAttachment&s3Id=${s3Id}&fileName=${fileName}" target="_blank">${data}</a>`;
                    }
                }
            ],
            data: []
        });
    }

    populateAttachmentsTable(attachments: any[]): void {
        this.attachmentsTable.clear();
        this.attachmentsTable.rows.add(attachments).draw();
    }

    initializeSitesFilters(): void {
        $('#filter-site-study-dropdown').empty();
        let studyValues: string[] = Unique(this.assignedSites.map(site => site.StudyName), true, ["None Selected"]);
        InitializeFilterDropdown('#filter-site-study-dropdown', studyValues, this);
        $('#filter-site-study-dropdown').on('change', () => this.triggerSitesTableFilter());
        $('#filter-sites-search-input').on('input', () => {
            this.sitesTable.search(String($('#filter-sites-search-input').val() ?? '')).draw();
        });
        $('#filter-sites-search-clear').on('click', () => {
            $('#filter-sites-search-input').val('');
            this.sitesTable.search('').draw();
        });
    }

    triggerSitesTableFilter(): void {
        const selectedStudy = this.getSelectedDropdownValues('#filter-site-study-dropdown');
        let matchingSites = this.assignedSites.filter(site => {
            if (!selectedStudy || selectedStudy.length === 0 || selectedStudy.includes("None Selected")) return true;
            return selectedStudy.includes(site.StudyName);
        });
        this.sitesTable.clear();
        this.sitesTable.rows.add(matchingSites).draw();
    }

    initializeContactsFilters(): void {
        $('#filter-contact-study-dropdown').empty();
        $('#filter-contact-role-dropdown').empty();
        let studyValues: string[] = Unique([].concat(...this.assignedContacts.map(contact => contact.StudyNames)), true, ["None Selected"]);
        InitializeFilterDropdown('#filter-contact-study-dropdown', studyValues, this);
        let roleValues: string[] = Unique([].concat(...this.assignedContacts.map(contact => contact.Role)), true, ["None Selected"]);
        InitializeFilterDropdown('#filter-contact-role-dropdown', roleValues, this);
        $('#filter-contact-study-dropdown, #filter-contact-role-dropdown').on('change', () => this.triggerContactsTableFilter());
        $('#filter-contacts-search-input').on('input', () => {
            this.contactsTable.search(String($('#filter-contacts-search-input').val() ?? '')).draw();
        });
        $('#filter-contacts-search-clear').on('click', () => {
            $('#filter-contacts-search-input').val('');
            this.contactsTable.search('').draw();
        });
        if (this.currentSiteName) {
            $('#filter-contacts-search-input').val(this.currentSiteName);
            this.contactsTable.search(this.currentSiteName).draw();
        }
    }

    triggerContactsTableFilter(): void {
        const selectedStudy = this.getSelectedDropdownValues('#filter-contact-study-dropdown');
        const selectedRole = this.getSelectedDropdownValues('#filter-contact-role-dropdown');
        let matchingContacts = this.assignedContacts.filter(contact => {
            let studyMatch = (!selectedStudy || selectedStudy.length === 0 || selectedStudy.includes("None Selected")) || contact.StudyNames.some((sn: string) => selectedStudy.includes(sn));
            let roleMatch = (!selectedRole || selectedRole.length === 0 || selectedRole.includes("None Selected")) || contact.Role.some((rn: string) => selectedRole.includes(rn));
            return studyMatch && roleMatch;
        });
        this.contactsTable.clear();
        this.contactsTable.rows.add(matchingContacts).draw();
    }

    initializeUsersFilters(): void {
        $('#filter-user-study-dropdown').empty();
        let studyValues: string[] = Unique([].concat(...this.assignedUsers.map(user => user.Studies)), true, ["None Selected"]);
        InitializeFilterDropdown('#filter-user-study-dropdown', studyValues, this);
        $('#filter-user-study-dropdown').on('change', () => this.triggerUsersTableFilter());
        $('#filter-users-search-input').on('input', () => {
            this.usersTable.search(String($('#filter-users-search-input').val() ?? '')).draw();
        });
        $('#filter-users-search-clear').on('click', () => {
            $('#filter-users-search-input').val('');
            this.usersTable.search('').draw();
        });
    }

    triggerUsersTableFilter(): void {
        const selectedStudy = this.getSelectedDropdownValues('#filter-user-study-dropdown');
        let matchingUsers = this.assignedUsers.filter(user => {
            if (!selectedStudy || selectedStudy.length === 0 || selectedStudy.includes("None Selected")) return true;
            return user.Studies && user.Studies.some((study: string) => selectedStudy.includes(study));
        });
        this.usersTable.clear();
        this.usersTable.rows.add(matchingUsers).draw();
    }

    initializeActionItemsFilters(): void {
        $('#commActionItem-type-dropdown').empty();
        $('#commActionItem-site-dropdown').empty();
        $('#commActionItem-status-dropdown').empty();
        let typeValues: string[] = (this.actionItems ? this.actionItems.map((ai: any) => ai.type) : []);
        InitializeFilterDropdown('#commActionItem-type-dropdown', Unique(typeValues, true, ["None Selected"]), this);
        let siteValues: string[] = (this.actionItems ? this.actionItems.map((ai: any) => ai.siteName) : []);
        InitializeFilterDropdown('#commActionItem-site-dropdown', Unique(siteValues, true, ["None Selected"]), this);
        let statusValues: string[] = (this.actionItems ? this.actionItems.map((ai: any) => ai.status) : []);
        InitializeFilterDropdown('#commActionItem-status-dropdown', Unique(statusValues, true, ["None Selected"]), this);
        $('#commActionItem-type-dropdown, #commActionItem-site-dropdown, #commActionItem-status-dropdown').on('change', () => this.triggerActionItemsTableFilter());
        $('#filter-actionItem-search-input').on('input', () => {
            this.actionItemsTable.search(String($('#filter-actionItem-search-input').val() ?? '')).draw();
        });
        $('#filter-actionItem-search-clear').on('click', () => {
            $('#filter-actionItem-search-input').val('');
            this.actionItemsTable.search('').draw();
        });
    }

    triggerActionItemsTableFilter(): void {
        const selectedType = this.getSelectedDropdownValues('#commActionItem-type-dropdown');
        const selectedSite = this.getSelectedDropdownValues('#commActionItem-site-dropdown');
        const selectedStatus = this.getSelectedDropdownValues('#commActionItem-status-dropdown');
        let matchingItems: any[] = [];
        let allItems = this.actionItems ? this.actionItems : [];
        allItems.forEach(item => {
            let typeMatch = (!selectedType || selectedType.length === 0 || selectedType.includes("None Selected")) || selectedType.includes(item.type);
            let siteMatch = (!selectedSite || selectedSite.length === 0 || selectedSite.includes("None Selected")) || selectedSite.includes(item.siteName);
            let statusMatch = (!selectedStatus || selectedStatus.length === 0 || selectedStatus.includes("None Selected")) || selectedStatus.includes(item.status);
            if (typeMatch && siteMatch && statusMatch) {
                matchingItems.push(item);
            }
        });
        this.actionItemsTable.clear();
        this.actionItemsTable.rows.add(matchingItems).draw();
    }

    initializeAttachmentsFilters(): void {
        $('#communicationEvent-attachmentType-dropdown').empty();
        let typeIdValues: string[] = (this.attachments ? this.attachments.map((ai: any) => ai.attachmentTypeId) : []);
        let typeValues: string[] = typeIdValues.map(tid => {
            const typeObj = this.attachmentTypes.find(t => String(t.Id) === String(tid));
            return typeObj ? typeObj.Name : tid;
        });
        InitializeFilterDropdown('#communicationEvent-attachmentType-dropdown', Unique(typeValues, true, ["None Selected"]), this);
        $('#communicationEvent-attachmentType-dropdown').on('change', () => this.triggerAttachmentsTableFilter());
        $('#custom-attachments-dt-search').on('input', () => {
            this.attachmentsTable.search(String($('#custom-attachments-dt-search').val() ?? '')).draw();
        });
        $('#clear-attachments-dt-search').on('click', () => {
            $('#custom-attachments-dt-search').val('');
            this.attachmentsTable.search('').draw();
        });
    }

    triggerAttachmentsTableFilter(): void {
        const selectedType = this.getSelectedDropdownValues('#communicationEvent-attachmentType-dropdown');
        const selectedTypeIds = this.attachmentTypes
            .filter(t => selectedType.includes(t.Name))
            .map(t => t.Id);
        let matchingAttachments = this.attachments.filter(attachment => {
            if (!selectedType || selectedType.length === 0 || selectedType.includes("None Selected")) return true;
            return selectedTypeIds.includes(attachment.attachmentTypeId);
        });
        this.attachmentsTable.clear();
        this.attachmentsTable.rows.add(matchingAttachments).draw();
    }

    getSelectedDropdownValues(selectId: string): any {
        return $(selectId).val();
    }

    triggerFilter(): void { }
    resetFilters(): void { }
}
